module.exports = __webpack_public_path__ + "img/data-collect.ffaec274.png";